// app/shared/providers/RealtimeNotificationsProvider.tsx
"use client";
import React from "react";

/**
 * Intentional no-op. PUC (personalized use case) status updates were
 * permanently migrated from a client-side Supabase Realtime subscription to
 * a server-side DB webhook (`app/api/personalized-use-cases/webhook/route.ts`
 * + `UPDATE_STRATEGY_CONFIG.useWebhookUpdates`, commit 575b9b6f) — this is
 * NOT a temporary crash workaround still pending a re-enable. Kept as an
 * explicit extension point for a future genuinely global realtime need;
 * do not wire `useRealtimePucNotifications()` back in here — that hook's
 * DB listeners were deliberately removed, not disabled.
 */
export function RealtimeNotificationsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
